import fEvents from '../../js/events';

export enum INPUT_STATE {
    loading = 'loading',
    error = 'error',
    none = 'none',
    ok = 'ok'
}

export default class InputStatefull extends HTMLElement {

    private props: {
        name: string,
        value: string,
        type: string,
        width: string,
        placeholder: string,
        state: INPUT_STATE
        disabled: string;
    };

    constructor() {
        super();
        this.props = {
            name: '',
            value: '',
            type: 'text',
            placeholder: 'Type here...',
            width: '200px',
            state: INPUT_STATE.none,
            disabled: 'false'
        };
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = this.render();
        let timer;
        fEvents.attachEvent('input', 'input', () => {
            clearTimeout(timer);
            timer = setTimeout( () => this._onValueChanged(), 0);
        }, this.shadowRoot);

        fEvents.attachEvent('.password-visibility', 'click', ()=> this.togglePassword(), this.shadowRoot);

    }

    renderPasswordVisibilityToggle() {
        const visibilityToggleIcon = this.shadowRoot.querySelector('.password-visibility') as HTMLElement;
        if (this.props.type !== 'password') {
            visibilityToggleIcon.style.display = 'none';
        }
    }

    togglePassword() {
        const visibilityToggleIcon = this.shadowRoot.querySelector('.password-visibility') as HTMLElement;
        const input = this.shadowRoot.querySelector(`input[name=${this.props.name}]`) as HTMLInputElement;
        const isPasswordVisible = input.type !== 'password';

        if (isPasswordVisible) {
            this.shadowRoot.querySelector('input').type = 'password';
            visibilityToggleIcon.innerHTML = 'visibility';
        } else {
            this.shadowRoot.querySelector('input').type = 'text';
            visibilityToggleIcon.innerHTML = 'visibility_off';
        }
    }

    attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {

        if (!InputStatefull.observedAttributes.includes(attrName)) {
            return; // not a valid field
        }
        this.props[attrName] = newVal;
        const classList = this.shadowRoot.getElementById('container').classList;
        switch (attrName) {
            case 'state' :
                Object.keys(INPUT_STATE).forEach(key => classList.remove(`input__${key.toLowerCase()}`));
                classList.add(`input__${newVal.toLowerCase()}`);
                break;
            case 'type' :
            case 'name' :
            case 'placeholder' :
            case 'value' :
                this.shadowRoot
                    .querySelector('input')
                    .setAttribute(attrName, newVal);
                this.renderPasswordVisibilityToggle();
                break;
            case 'width':
                this.shadowRoot
                    .host
                    .setAttribute('style', 'width:' + newVal);
                break;
            case 'inputstyle':
                this.shadowRoot.querySelector('input').setAttribute('style', newVal);
                break;
            case 'disabled':
                if (newVal === 'true') this.shadowRoot.querySelector('input').setAttribute('disabled', newVal);
                break;
        }
    }

    public getValue() {
        return this.props.value;
    }

    public setValue(value: string) {
        this.props.value = value;
        const input = this.shadowRoot
            .querySelector('input');
        input.value = value;
        this._onValueChanged();

    }

    static get observedAttributes(): string[] {
        return ['value', 'type', 'name', 'state', 'width', 'placeholder', 'disabled', 'inputclass', 'inputstyle'];
    }

    private _onValueChanged() {
        const input = this.shadowRoot
            .querySelector('input') as HTMLInputElement;
        this.props.value = input.value;
        this.setAttribute('value', input.value);
        fEvents.dispatch(this, 'value-changed', {
            value: input.value
        });
    }

    render = () => `
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
        <link rel="stylesheet" href="/styles/styles.css" type="text/css">
        <link rel="stylesheet" href="/styles/index.css" type="text/css">
        <style>
            :host {
                display: block;
            }
            
            .text {
                padding: 50px;
                font-family: "Sans-Serif";
                color: #666;
            }
            
            .container {
                position: relative;
                display: block;
            }
            
            input, input[type="text"] {
                border: 1px solid #CDD5E4;
                width: 100%;
                border-radius: 3px;
                padding: 18px 10px;
                box-sizing: border-box;
                box-shadow: 0 8px 35px 0 rgb(0 0 0 / 10%);
                background-color: #ffffff;
                outline: none;
                font-size: 14px;
            }
            
            input:disabled {
                opacity: 0.5;
            }
            
            .icon-container {
                position: absolute;
                right: 16px;
                top: calc(50% - 12px);
            }
            
            .loader {
                position: relative;
                height: 20px;
                width: 20px;
                display: none;
                animation: around 5.4s infinite;
            }
            
            .input__loading .loader {
                display: inline-block;
            }
            .error { display: none; color: var(--error) }
            .input__error .error { display: inline-block }
            .ok { display: none; color: #3fb848 }
            .input__ok .ok { display: inline-block }
            
            @keyframes around {
              0% {
                transform: rotate(0deg)
              }
              100% {
                transform: rotate(360deg)
              }
            }
            
            .loader::after, .loader::before {
                content: "";
                background: white;
                position: absolute;
                display: inline-block;
                width: 100%;
                height: 100%;
                border-width: 2px;
                border-color: #333 #333 transparent transparent;
                border-style: solid;
                border-radius: 20px;
                box-sizing: border-box;
                top: 0;
                left: 0;
                animation: around 0.7s ease-in-out infinite;
            }
            
            .loader::after {
                animation: around 0.7s ease-in-out 0.1s infinite;
                background: transparent;
            }
            
            .password-visibility{
                cursor: pointer;
                padding: 0px 8px;
            }
        </style>
        <div id="container" class="container input__${this.props.state.toLowerCase()}">
            <input
                type="${ this.props.type }" name="${ this.props.name }" value="${ this.props.value }" class="mdl-textfield__input fl-textfield-input" 
                placeholder="${ this.props.placeholder }" />
            <div class="icon-container">
              <i class="material-icons password-visibility">visibility</i>
              <i class="loader"></i>
              <i class="material-icons error">error</i>
              <i class="material-icons ok">check</i>
            </div>
        </div>
    `;
}

customElements.define('input-statefull', InputStatefull);
